import useStore from "@src/stores/store";
import {useAuthStore} from "@src/stores/auth";
import axios from "axios";

axios.defaults.withCredentials = true;
axios.defaults.baseURL = import.meta.env.VITE_DCHAT_URL ?? "http://localhost";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["Content-Type"] = "application/json";

try {
    await axios.get('/sanctum/csrf-cookie');
} catch (e) {
    console.error(e)
    Promise.reject(e);
}

// 401 voltar pro login e limpar tudo
axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        const status = error?.response?.status;
        const store = useStore();
        const auth = useAuthStore();

        if (status === 403 && store.status !== 'blocked') {
            //redireciona para a tela de bloqueio
            store.setStatus('blocked')
        } else if (status === 401) {
            // limpa stores
            auth.user = null;
            auth.clearStorage();
            store.goToLogin();
        }

        return Promise.reject(error);
    }
);

axios.interceptors.request.use(config => {
    const token = localStorage.getItem('dchatToken');

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

// @ts-ignore
window.axios = axios;